import Vue from 'vue'

const currencySymbol = function (currency) {
  switch (currency.toUpperCase()) {
    case 'USD':
      return '$'
    case 'EUR':
      return '€'
    default:
      return currency.toUpperCase()
  }
}

const plugin = function (Vue, options) {
  Vue.prototype.$currencySymbol = currencySymbol
  Vue.$currencySymbol = currencySymbol
}

Vue.use(plugin)
